export const categories = [
    { id: 1, type: "PersonalBlogs" },
    { id: 2, type: "TravelBlogs" },
    { id: 3, type: "FashionAndStyleBlogs" },
    { id: 4, type: "FoodAndCookingBlogs" },
    { id: 5, type: "HealthAndWellnessBlogs" },
    { id: 6, type: "ParentingBlogs" },
    { id: 7, type: "TechnologyAndGadgetsBlogs" },
    { id: 8, type: "BusinessAndEntrepreneurshipBlogs" },
    { id: 9, type: "FinanceAndMoneyBlogs" },
    { id: 10, type: "LifestyleBlogs" },
    { id: 11, type: "DIYandCraftsBlogs" },
    { id: 12, type: "PhotographyBlogs" },
    { id: 13, type: "PoliticalAndNewsBlogs" },
    { id: 14, type: "SportsBlogs" },
    { id: 15, type: "GamingBlogs" },
    { id: 16, type: "EducationBlogs" }
];
